function getData(element){
  if(element){
    return element.getAttribute('value')
  }else{
    return ""
  }
}

export function dataFromDom(dom) {
    var result = new DOMParser().parseFromString(dom, "text/html");
    return {
        title: result.title,//know what page am parsing
        mac: getData(result.getElementById('mac')),
        ip: getData(result.getElementById('ip')),
        linklogin: getData(result.getElementById('linklogin')),
        linkorig: getData(result.getElementById('linkorig')),
        linkstatus: getData(result.getElementById('linkstatus')),
        linkloginonly: getData(result.getElementById('linkloginonly')),
        username: getData(result.getElementById('username')),
        password: getData(result.getElementById('password')),
        router: getData(result.getElementById('identity')),
        serveraddress: getData(result.getElementById('serveraddress')),
        idletimeout: getData(result.getElementById('idletimeout')),
        timeleft: getData(result.getElementById('sessiontimeleft')),
        secondsleft: getData(result.getElementById('sessiontimeleftsecs')),
        uptime: getData(result.getElementById('uptime')),
        uptimesecs: getData(result.getElementById('uptimesecs')),
        bytesin: getData(result.getElementById('bytesin')),
        bytesout: getData(result.getElementById('bytesout')),
        bytesinnice: getData(result.getElementById('bytesinnice')),
        bytesoutnice: getData(result.getElementById('bytesoutnice')),
        remainbytesin: getData(result.getElementById('remainbytesin')),
        remainbytesout: getData(result.getElementById('remainbytesout')),
        error: getData(result.getElementById('error'))
    }
}
